// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:400,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament h1{
    margin: 5px;
    font-size: 20px;
    text-align: center;
}
.tournament h2{

    font-size: 20px;
    text-align: center;
}
.tournament_block{
    display: flex;
    justify-content: flex-end;
}
.tournament{
    margin: 10px;
    border-radius: 20px;
    max-width: 350px;
    background: linear-gradient(331.49deg, rgba(75, 135, 148, 0.1) -1.05%, rgba(255, 255, 255, 0) 23.13%), radial-gradient(102.7% 102.44% at 0px -1.46%, rgba(26, 136, 243, 0.5) 0px, rgba(10, 16, 30, 0) 100%), linear-gradient(313.94deg, rgb(75, 95, 139) -1.46%, rgba(20, 27, 46, 0.6) 101.92%);
    font-size: 20px;

    display: flex;
    justify-content: flex-end;

    flex-direction: column;

    overflow: hidden;

}

.container_enter {

    min-height: 100vh;
    font-family: 'Lato', sans-serif;

    margin: 0;
    overflow: auto;
    margin-top:60px;
    margin-bottom: 80px;
    color: #0a0a0b;

}
.tournament h1 span{
    color: greenyellow;
}
@media (max-width: 605px) {
    .tournament_block {
        display: flex;
        justify-content: center;
    }
}
@keyframes gradient {
    0% {
        background-position: 0% 0%;
    }
    50% {
        background-position: 100% 100%;
    }
    100% {
        background-position: 0% 0%;
    }
}
.btn_quick_start {
    font-family: 'Lato', sans-serif;
    background-image: linear-gradient(to right, #1A2980 0%, #26D0CE  51%, #1A2980  100%);
    margin: 10px;
    margin-top: 20px;
    padding: 15px 45px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;

    border-radius: 10px;
    display: block;
}

.btn_quick_start:hover {
    background-position: right center; /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}






a {
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    opacity: 0.9;
}

a:hover {
    opacity: 1;
}

h1 {
    font-size: 3rem;
    font-weight: 700;
    color: #fff;
    margin: 0 0 1.5rem;
}






a.btn {
    color: #fff;
    padding: 10px;
    border: 1px solid rgba(255,255,255,0.5);
    transition: all 0.2s;
}

a.btn:hover {
    background: #d73851;
    border: 1px solid #d73851;
    color: #fff;
}
.custom-alert {
    font-family: 'Lato', sans-serif;
    position: fixed;
    top: 50%;
    left: 50%;
    color:red;
    transform: translate(-50%, -50%);
    z-index: 9999;
    animation: drop-down 0.5s ease-in-out;
}

@keyframes drop-down {
    0% {
        opacity: 0;
        transform: translate(-50%, -100%);
    }
    100% {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
}
.cover  {
    margin-top: 20px;
    width: 100%;

    padding: 20px 50px;
    display: flex;
    flex-direction: column;

    justify-content: center;

    align-items: center;
}


.flex-form input[type="submit"] {
    background-image: linear-gradient(to right, #000000 0%, #53346D  51%, #000000  100%);

    color: white;
    padding: 0 30px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;

    cursor: pointer;
    /*-webkit-transition: all 0.2s;*/
    /*-moz-transition: all 0.2s;*/

}

.flex-form input[type="submit"]:hover {
    background-position: right center; /* change the direction of the change here */

    text-decoration: none;
}

.flex-form {
    display: flex;
    z-index: 10;
    position: relative;

    width: 500px;
    box-shadow: 4px 8px 16px rgba(0, 0, 0, 0.3);
}

.flex-form > * {
    border: 0;
    padding: 0 0 0 10px;
    background: #fff;
    line-height: 50px;
    font-size: 1rem;
    border-radius: 5px;
    outline: 0;
    -webkit-appearance: none;
}

input[type="search"] {
    color: white;
    background-color: #070c1b;
    flex-basis: 500px;
}

#madeby {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 25px 100px;
    color: #fff;
}

@media all and (max-width:1000px) {
    body {
        font-size: 0.9rem;
    }

    .flex-form {
        width: 100%;
    }

    input[type="search"] {
        flex-basis: 100%;
    }

    .flex-form > * {
        font-size: 0.9rem;
    }

    

    header h2 {
        margin-bottom: 15px;
    }

    h1 {
        font-size: 2rem;
    }

    .cover {
        padding: 20px;
    }

    #madeby {
        padding: 30px 20px;
    }
}

@media all and (max-width:360px) {
    header nav li{
        margin: 0 10px;
    }

    .flex-form {
        display: flex;
        flex-direction: column;
    }

    input[type="search"] {
        flex-basis: 0;
    }

    label {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Free_rooms/index.css"],"names":[],"mappings":"AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;AACA;;IAEI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,+RAA+R;IAC/R,eAAe;;IAEf,aAAa;IACb,yBAAyB;;IAEzB,sBAAsB;;IAEtB,gBAAgB;;AAEpB;;AAEA;;IAEI,iBAAiB;IACjB,+BAA+B;;IAE/B,SAAS;IACT,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,cAAc;;AAElB;AACA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,aAAa;QACb,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,8BAA8B;IAClC;IACA;QACI,0BAA0B;IAC9B;AACJ;AACA;IACI,+BAA+B;IAC/B,oFAAoF;IACpF,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY;;IAEZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iCAAiC,EAAE,4CAA4C;IAC/E,WAAW;IACX,qBAAqB;AACzB;;;;;;;AAOA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;;;;;;AAOA;IACI,WAAW;IACX,aAAa;IACb,uCAAuC;IAGvC,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,+BAA+B;IAC/B,eAAe;IACf,QAAQ;IACR,SAAS;IACT,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI;QACI,UAAU;QACV,iCAAiC;IACrC;IACA;QACI,UAAU;QACV,gCAAgC;IACpC;AACJ;AACA;IACI,gBAAgB;IAChB,WAAW;;IAEX,kBAAkB;IAElB,aAAa;IAGb,sBAAsB;;IAEtB,uBAAuB;;IAEvB,mBAAmB;AACvB;;;AAGA;IACI,oFAAoF;;IAEpF,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;;IAE1B,eAAe;IACf,gCAAgC;IAChC,6BAA6B;;AAEjC;;AAEA;IACI,iCAAiC,EAAE,4CAA4C;;IAE/E,qBAAqB;AACzB;;AAEA;IAGI,aAAa;IACb,WAAW;IACX,kBAAkB;;IAElB,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;;;IAIA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QAEI,aAAa;QAGb,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Lato:400,700');\n\n.tournament h1{\n    margin: 5px;\n    font-size: 20px;\n    text-align: center;\n}\n.tournament h2{\n\n    font-size: 20px;\n    text-align: center;\n}\n.tournament_block{\n    display: flex;\n    justify-content: flex-end;\n}\n.tournament{\n    margin: 10px;\n    border-radius: 20px;\n    max-width: 350px;\n    background: linear-gradient(331.49deg, rgba(75, 135, 148, 0.1) -1.05%, rgba(255, 255, 255, 0) 23.13%), radial-gradient(102.7% 102.44% at 0px -1.46%, rgba(26, 136, 243, 0.5) 0px, rgba(10, 16, 30, 0) 100%), linear-gradient(313.94deg, rgb(75, 95, 139) -1.46%, rgba(20, 27, 46, 0.6) 101.92%);\n    font-size: 20px;\n\n    display: flex;\n    justify-content: flex-end;\n\n    flex-direction: column;\n\n    overflow: hidden;\n\n}\n\n.container_enter {\n\n    min-height: 100vh;\n    font-family: 'Lato', sans-serif;\n\n    margin: 0;\n    overflow: auto;\n    margin-top:60px;\n    margin-bottom: 80px;\n    color: #0a0a0b;\n\n}\n.tournament h1 span{\n    color: greenyellow;\n}\n@media (max-width: 605px) {\n    .tournament_block {\n        display: flex;\n        justify-content: center;\n    }\n}\n@keyframes gradient {\n    0% {\n        background-position: 0% 0%;\n    }\n    50% {\n        background-position: 100% 100%;\n    }\n    100% {\n        background-position: 0% 0%;\n    }\n}\n.btn_quick_start {\n    font-family: 'Lato', sans-serif;\n    background-image: linear-gradient(to right, #1A2980 0%, #26D0CE  51%, #1A2980  100%);\n    margin: 10px;\n    margin-top: 20px;\n    padding: 15px 45px;\n    text-align: center;\n    text-transform: uppercase;\n    transition: 0.5s;\n    background-size: 200% auto;\n    color: white;\n\n    border-radius: 10px;\n    display: block;\n}\n\n.btn_quick_start:hover {\n    background-position: right center; /* change the direction of the change here */\n    color: #fff;\n    text-decoration: none;\n}\n\n\n\n\n\n\na {\n    color: #fff;\n    text-decoration: none;\n    cursor: pointer;\n    opacity: 0.9;\n}\n\na:hover {\n    opacity: 1;\n}\n\nh1 {\n    font-size: 3rem;\n    font-weight: 700;\n    color: #fff;\n    margin: 0 0 1.5rem;\n}\n\n\n\n\n\n\na.btn {\n    color: #fff;\n    padding: 10px;\n    border: 1px solid rgba(255,255,255,0.5);\n    -webkit-transition: all 0.2s;\n    -moz-transition: all 0.2s;\n    transition: all 0.2s;\n}\n\na.btn:hover {\n    background: #d73851;\n    border: 1px solid #d73851;\n    color: #fff;\n}\n.custom-alert {\n    font-family: 'Lato', sans-serif;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    color:red;\n    transform: translate(-50%, -50%);\n    z-index: 9999;\n    animation: drop-down 0.5s ease-in-out;\n}\n\n@keyframes drop-down {\n    0% {\n        opacity: 0;\n        transform: translate(-50%, -100%);\n    }\n    100% {\n        opacity: 1;\n        transform: translate(-50%, -50%);\n    }\n}\n.cover  {\n    margin-top: 20px;\n    width: 100%;\n\n    padding: 20px 50px;\n    display: -webkit-box;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    flex-direction: column;\n\n    justify-content: center;\n\n    align-items: center;\n}\n\n\n.flex-form input[type=\"submit\"] {\n    background-image: linear-gradient(to right, #000000 0%, #53346D  51%, #000000  100%);\n\n    color: white;\n    padding: 0 30px;\n    text-align: center;\n    text-transform: uppercase;\n    transition: 0.5s;\n    background-size: 200% auto;\n\n    cursor: pointer;\n    /*-webkit-transition: all 0.2s;*/\n    /*-moz-transition: all 0.2s;*/\n\n}\n\n.flex-form input[type=\"submit\"]:hover {\n    background-position: right center; /* change the direction of the change here */\n\n    text-decoration: none;\n}\n\n.flex-form {\n\n    display: -webkit-box;\n    display: flex;\n    z-index: 10;\n    position: relative;\n\n    width: 500px;\n    box-shadow: 4px 8px 16px rgba(0, 0, 0, 0.3);\n}\n\n.flex-form > * {\n    border: 0;\n    padding: 0 0 0 10px;\n    background: #fff;\n    line-height: 50px;\n    font-size: 1rem;\n    border-radius: 5px;\n    outline: 0;\n    -webkit-appearance: none;\n}\n\ninput[type=\"search\"] {\n    color: white;\n    background-color: #070c1b;\n    flex-basis: 500px;\n}\n\n#madeby {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    padding: 25px 100px;\n    color: #fff;\n}\n\n@media all and (max-width:1000px) {\n    body {\n        font-size: 0.9rem;\n    }\n\n    .flex-form {\n        width: 100%;\n    }\n\n    input[type=\"search\"] {\n        flex-basis: 100%;\n    }\n\n    .flex-form > * {\n        font-size: 0.9rem;\n    }\n\n    \n\n    header h2 {\n        margin-bottom: 15px;\n    }\n\n    h1 {\n        font-size: 2rem;\n    }\n\n    .cover {\n        padding: 20px;\n    }\n\n    #madeby {\n        padding: 30px 20px;\n    }\n}\n\n@media all and (max-width:360px) {\n    header nav li{\n        margin: 0 10px;\n    }\n\n    .flex-form {\n        display: -webkit-box;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        flex-direction: column;\n    }\n\n    input[type=\"search\"] {\n        flex-basis: 0;\n    }\n\n    label {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
